<!--查看報到紀錄畫面-->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app id="cheerfulgive-checkInRecord">
    <v-main>
       <v-form ref="form" :model="queryData">
      <v-container fluid class="mb-8 pl-16 pr-16">
        <!-- 上方左右側按鈕 -->
        <div class="d-flex justify-space-between">
          <v-btn color="primary" elevation="2" outlined x-large class="text-h6" :ripple="false" @click="back">
            <icon-reply class="cheerfulgive-icon" />
            {{ $t('back') }}
          </v-btn>
        </div>
        <div class="ac-meta">
          <v-row justify="center">
            <img src="@/assets/images/cheerfulgive-logo.png" alt="cheerfulgive-logo" class="logo-img">
          </v-row>
           <v-row justify="center" class="pt-10">
            <h2>{{ $t('checkInRecord') }}</h2>
          </v-row>
          <v-row justify="center">
            <hr style="width:12em; background-color:#FEAA3C; height:1.5px; border-width:0;">
          </v-row>
          </div>

        <div class="mt-14">
          <!--已售票券(報名人數)-->
          <p class="text-h6">
              {{ $t('signPeople') }}：{{signPeople}}
          </p>
          <!--已使用票券(報到人數)-->
          <p class="text-h6">
              {{ $t('checkInPeople') }}：{{checkInPeople}}
          </p>
           <!--未使用票券-->
           <p class="text-h6">
              {{ $t('newticket') }}：{{signPeople-checkInPeople}}
          </p>
          <!--實際報到人數-->
          <p class="text-h6">
            {{ $t('actualPeople') }}：{{actualPeople}}
          </p>
          <!--待報到人數-->
          <p class="text-h6">
            {{ $t('waitCheckInPeople') }}：{{waitCheckInPeople}}
          </p>
        </div>

          <!--查看條件-->
        <div class="mt-14">
          <span class="font-weight-medium">
            {{ $t('optionCheck') }}
          </span>
           <v-radio-group
              v-model="queryData.queryType"
              @change="selectOption"
              row
            >
              <v-radio
                :label="$t('allSignUp')"
                value="ALL"
              ></v-radio>
              <v-radio
                :label="$t('checkInAlready')"
                value="CHECKIN"
              ></v-radio>
              <v-radio
                :label="$t('noUse')"
                value="NO"
              ></v-radio>
            </v-radio-group>
        </div>

        <!--表格-->
        <div>
          <v-simple-table id="list-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left text-h6 primary--text th-border">{{ $t('fullName') }}</th>
                  <th class="text-left text-h6 primary--text th-border">{{ $t('registrationTime') }}</th>
                  <th class="text-left text-h6 primary--text th-border">{{ $t('cellphoneNumber') }}</th>
                  <th class="text-left text-h6 primary--text th-border">{{ $t('ticketNumber') }}</th>
                  <th class="text-left text-h6 primary--text th-border">{{ $t('actualPeople') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="list, index in lists" :key="index">
                  <td class="text-left text-body-1 secondary--text py-8 td-border">{{ list.payerFullName }}</td>
                  <td class="text-left text-body-1 secondary--text py-8 td-border">{{ list.registrationTimeStr }}</td>
                  <td class="text-left text-body-1 secondary--text py-8 td-border">{{ list.payerCellphone }}</td>
                  <td class="text-left text-body-1 secondary--text py-8 td-border">{{ list.ticketNumber }}</td>
                  <td class="text-left text-body-1 secondary--text py-8 td-border">{{ list.actualPeople }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-container>
      </v-form>
    </v-main>
  </v-app>
</template>

<script>
import IconReply from '@/assets/icons/reply.vue'
import API from '../../apis'

export default {
  name: 'CheckInRecord',
  components: { IconReply },

  data () {
    return {
      isLoading: false,
      queryData: {
        lessonId: '',
        needTotal: true,
        queryType: 'ALL',
        max: 999
      },
      signPeople: null,
      checkInPeople: null,
      actualPeople: null,
      waitCheckInPeople: null,
      lists: []
    }
  },

  created () {
    const params = new URLSearchParams(window.location.search)
    this.queryData.lessonId = params.get('id')
    this.checkInQuery()
  },

  methods: {
    back () {
      this.$router.push(`/scanQrCode?id=${this.queryData.lessonId}`)
    },

    resetValidation () {
      this.$refs.queryData.resetValidation()
    },

    resetFileds () {
      this.queryData.queryType = 'ALL'
    },

    checkInQuery () {
      this.isLoading = true
      API.ticket
        .index({ ...this.queryData })
        .then((res) => {
          this.signPeople = res.data.signPeople
          this.checkInPeople = res.data.checkInPeople
          this.actualPeople = res.data.actualPeople
          this.waitCheckInPeople = res.data.waitCheckInPeople
          this.lists = res.data.list
          this.isLoading = false
        })
    },

    // 「查看條件」篩選
    selectOption () {
      API.ticket
        .index({ ...this.queryData })
        .then((res) => {
          this.signPeople = res.data.signPeople
          this.checkInPeople = res.data.checkInPeople
          this.actualPeople = res.data.actualPeople
          this.waitCheckInPeople = res.data.waitCheckInPeople
          this.lists = res.data.list
          this.isLoading = false
        })
    }
  }

}
</script>

<style>
/*log尺寸*/
.logo-img {
  width: 50%;
  margin-top: 60px;
}

.ac-meta h2 {
  color:#FEAA3C;
  font-size: 1.6em;
  letter-spacing: 3px;
}

/*分隔線顏色與寬度設定*/
.theme--light.v-divider {
  border-width: 2px !important;
  border-color: #FEAA3C !important;
}

.th-border {
  border-bottom-width: 2px !important;
  border-bottom-style: solid !important;
  border-bottom-color: var(--v-primary-base) !important;
}
.td-border {
  border-bottom-width: 1px !important;
  border-bottom-style: solid !important;
  border-bottom-color: var(--v-primary-lighten2) !important;
}
#record-table tbody tr:hover {
  background-color: var(--v-primary-lighten2) !important;
}
</style>
